import { useReactFlow } from "@xyflow/react";
import { useCallback } from "react";

export const useFitViewWithDelay = () => {
  const { fitView } = useReactFlow();
  const fitViewWithDelay = useCallback(() => {
    setTimeout(() => {
      void fitView();
    }, 100);
  }, [fitView]);
  return fitViewWithDelay;
};
